import ProductSystems from "@/components/ProductSystems.vue";
import * as themeColors from "@assets/styles/colors.module.scss";
import { builderCta } from "@/helpers/builder-init/index";
import { useBuilderShowIf } from "../composables/builderFieldUtility";
const colors = ["None", ...Object.keys(themeColors)];
const { hasValue, hasValueEqualTo, hasRichText } = useBuilderShowIf();

const columnSubFields = [
    {
        name: "heading",
        type: "object",
        subFields: [
            {
                name: "text",
                friendlyName: "Text",
                type: "string"
            },
            {
                name: "color",
                type: "string",
                enum: colors,
                showIf: hasValue("text")
            }
        ]
    },
    {
        name: "descriptionPosition",
        friendlyName: "Description Position",
        type: "string",
        enum: ['above cta', 'below cta']
    },
    {
        name: "description",
        type: "object",
        subFields: [
            {
                name: "text",
                friendlyName: "Text",
                type: "richText"
            },
            {
                name: "color",
                type: "string",
                enum: colors,
                showIf: hasRichText("text")
            }
        ]
    },
    {
        name: "cta",
        type: "object",
        defaultValue: { type: "button", style: "primary" },
        subFields: [...builderCta.subFields]
    }
];

const badgeSubField = {
    name: "badge",
    type: "object",
    defaultValue: {
        width_mobile: "60",
        width_desktop: "100",
        alt_text: "Badge"
    },
    subFields: [
        {
            name: "image",
            type: "file",
            helperText: "Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
            allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"]
        },
        {
            name: "width_desktop",
            friendlyName: "Desktop Width (px)",
            type: "number",
            showIf: hasValue("image")
        },
        {
            name: "width_mobile",
            friendlyName: "Mobile Width (px)",
            type: "number",
            showIf: hasValue("image")
        },
        {
            name: "alt_text",
            friendlyName: "Alt Text",
            type: "string",
            showIf: hasValue("image")
        }
    ]
};

const imageSubField = {
    name: "media",
    type: "object",
    defaultValue: {},
    subFields: [
        {
            name: "image",
            type: "file",
            helperText: "Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
            allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"]
        },
        {
            name: "alt_text",
            type: "string",
            showIf: hasValue("image"),
            required: true
        },
        {
            name: "aria_label",
            type: "string",
            showIf: hasValue("image"),
            required: true
        }
    ]
};

export const productSystemsInit = {
    component: ProductSystems,
    name: "ProductSystems",
    models: ["category-landing-content", "campaign-content", "content-section"],
    inputs: [
        {
            name: "bg_color",
            type: "string",
            enum: colors,
            friendlyName: "Background Color",
            defaultValue: "None"
        },
        {
            name: "column_one",
            type: "object",
            defaultValue: {
                heading: "",
                description: "",
                cta: {},
                badge: {}
            },
            subFields: [...columnSubFields, badgeSubField]
        },
        {
            name: "column_two",
            type: "object",
            defaultValue: {
                heading: "",
                description: "",
                cta: {},
                image: {}
            },
            subFields: [...columnSubFields, imageSubField]
        },
        {
            name: "column_three",
            type: "object",
            defaultValue: {
                heading: "",
                description: "",
                cta: {},
                image: {}
            },
            subFields: [...columnSubFields, imageSubField]
        },
        {
            name: "column_four",
            type: "object",
            defaultValue: {
                heading: "",
                description: "",
                cta: {},
                image: {}
            },
            subFields: [...columnSubFields, imageSubField]
        }
    ]
};
